import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import { useTheme, Badge, Drawer, makeStyles } from '@material-ui/core'
import DeleteBtn from 'components/Custom/DeleteBtn'
import { useAuthContext } from 'hooks/useAuthContext'
import Button from '@material-ui/core/Button'
import AttachFile from '@material-ui/icons/AttachFile'
import StaticInspForm from 'components/FieldTests/StaticInspForm'
import EditBtn from 'components/Custom/EditBtn'
import Chip from '@material-ui/core/Chip'
import withAppStylesGrid from 'HOCs/withAppStyles';

const useStyles = makeStyles((theme) => ({
    label: {
        width: '250px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));

const Grid = ({ columns, title, getRecords, selectedProject, component, formPath, deleteRecord, dynamicForm = false, dynamicFormUpdate, paging = true, selection = { "display": false, "SAMPLE_CD": "", "Status": "" }, data = [], FileUploadDialog, PassFail = false, handleFile, showEditIcon = true }) => {
    const theme = useTheme();
    const [updateDate, setUpdateDate] = useState(new Date());
    const [editable, setEditable] = useState({});
    const [action, setAction] = useState(null);
    const { role } = useAuthContext();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerContent, setDrawerContent] = useState(null);
    const classes = useStyles();
    const [detailsPanel, setDetailsPanel] = useState(null)

    const handleInspClick = (event) => {
        event.stopPropagation()
        setDrawerOpen(true)
        const inspNumber = event.target.valueOf().innerText
        setDrawerContent(() => (
            <StaticInspForm inspectionNumber={inspNumber} />
        ))
    };


    const _getRecords = data.length > 0 ? data : async (page, pageSize, orderBy, orderDirection, search, _filters) => {
        const r = await getRecords(page, pageSize, orderBy, orderDirection, { SAMPLE_CD: selection.SAMPLE_CD, Status: selection.Status }, _filters);
        selection.getSampleData !== undefined && selection.getSampleData(r.data)
        return {
            data: r.data,
            count: r.count
        }
    };
    const GridWithAppStyles = withAppStylesGrid(MaterialTable, { theme, getRecords: _getRecords, defaultFilters: { projectId: selectedProject } })

    useEffect(() => {
        const handleChange = () => {
            dynamicForm && dynamicFormUpdate()
            setUpdateDate(new Date())
        }
        role && dynamicForm && !PassFail && setEditable(DeleteBtn(setUpdateDate, deleteRecord, selectedProject)) // delete
        role && role.check(component, 'update') && !dynamicForm && !PassFail && showEditIcon && setAction(true)   // edit
        role && role.check(component, 'read') && dynamicForm && setDetailsPanel(EditBtn(handleChange, formPath, PassFail))
    }, [role, selectedProject, updateDate, PassFail, dynamicForm, deleteRecord, component, showEditIcon, formPath, dynamicFormUpdate]);

    return (
        <div>
            <GridWithAppStyles
                key={updateDate}
                options={{
                    headerStyle: {
                        backgroundColor: theme.palette.grey[50],
                        color: theme.palette.text.primary,
                    },
                    selection: selection.display,
                    paging: paging,
                    toolbar: paging
                }}
                padding="default"
                columns={columns = columns.map(col => {
                    if (col.title === "Inspection #") {
                        col.render = (rowData) => (<a onClick={handleInspClick} href="#">{rowData[col.field]}</a>)
                    }
                    if (col.title === "Attachments") {
                        col.render = (rowData) => (<Badge badgeContent={rowData[col.field].length} color="secondary" showZero><AttachFile></AttachFile></Badge>)
                        col.cellStyle = { textAlign: 'left' }
                    }
                    if (col.title === "Attachment") {

                        col.render = (rowData) => {
                            if (rowData.FileUploadUid && rowData.FileUploadUid !== "") {
                                return <Chip
                                    className={classes.label}
                                    icon={<AttachFile />}
                                    label={rowData[col.field].slice(-30)}
                                    onDelete={e => handleFile(rowData)}
                                    onClick={e => handleFile(rowData, false)}
                                    variant="outlined"
                                />
                            }
                        }
                        col.cellStyle = { textAlign: 'left' }

                    }
                    return col

                }).filter(r => !r.hide)}
                title={title}
                detailPanel={detailsPanel}
                editable={!PassFail && editable}
                actions={selection.display ? [
                    {
                        tooltip: selection.tooltip,
                        icon: () => <Button variant="outlined">{selection.btnText}</Button>,
                        onClick: (evt, data) => selection.callback(data)
                    }
                ] : dynamicForm && !PassFail ?
                    [
                        {
                            icon: 'attach_file',
                            tooltip: 'Attach PDF',
                            onClick: (event, rowData) => FileUploadDialog(rowData)
                        }
                    ]
                    : action ? [
                        {
                            icon: 'create_filled',
                            tooltip: '',
                            onClick: (event, data) => selection.callback(data)
                        }
                    ] : []
                }
            />
            <Drawer anchor="right" open={drawerOpen} onClose={() => { setDrawerOpen(false) }}>
                <div style={{ width: "25vw" }}>
                    {drawerContent}
                </div>
            </Drawer>
        </div>
    )
}

export default Grid